export const features = {
    "template": "template2",
    "companyName": "Northern Neck Insurance Company (Prod)",
    "inowEndpoint": "https://nnins.iscs.com",
    "tokenIssuer": "https://nnic-inow.okta.com/oauth2/default",
    "clientId": "0oa1qj9zsii4ny7IT1d8",
    "features": {
        "CustomContentPage1": true,
        "CustomContentPage2": true,
        "addRegistrationEmail": false,
        "affiliatedCarrierAccess": false,
        "agentEmail": true,
        "agentLink": true,
        "agentPanel": true,
        "blockAchNumberOps": false,
        "changeCoverage": true,
        "claimDetailsDocuments": false,
        "claimDetailsPayments": true,
        "claimDocumentUpload": true,
        "claimList": true,
        "claimStatus": true,
        "combinePolicies": true,
        "coverageDetails": true,
        "cpPortalLinking": false,
        "customPrivacyStatement": false,
        "customTOS": false,
        "deactivateUserOnly": false,
        "defaultLossDateTime": true,
        "desktopDeliveryPreferencesDefaultExpanded": true,
        "editPayPlan": false,
        "hasOpenBalance": true,
        "loginPanelExpirationDate": "2999-01-01",
        "mfaEnabled": false,
        "mobileDeliveryPreferencesDefaultExpanded": false,
        "needHelp": true,
        "notificationPreferences": false,
        "otherPaymentAmountAllowed": true,
        "paperlessChoiceUpdate": true,
        "passwordResetInfo": false,
        "payPlanTypesToFilter": [
            "Mortgagee",
            "Agent",
            "Statement"
        ],
        "pendingOrScheduledPaymentsList": true,
        "policyDetailsAddress": true,
        "policyDetailsAddressTypeCd": [],
        "policyDocumentUpload": true,
        "policyForms": false,
        "policyFormsDownload": false,
        "policyUserAttachmentsDisplay": true,
        "printButtonEnabled": false,
        "recentPaymentsList": true,
        "rememberMe": true,
        "reportClaim": true,
        "scheduledPayments": true,
        "showImageTag": true,
        "showInstallPWA": false,
        "standardPhoneLength": false,
        "unauthenticatedPayments": true,
        "unauthenticatedReportClaim": true,
        "underlyingPoliciesPayPlansEditable": false,
        "useGooglePlacesInReportClaimFlow": true,
        "useInsuredAttachments": true,
        "verifyAddress": true,
        "viewChangeRequests": true
    },
    "keys": {
        "googleAnalytics": "",
        "googleAnalytics4": "G-21465KTP3G",
        "googleAnalytics4GwDev": "G-R8Y22B4GYL",
        "googleAnalytics4GwProd": "G-C0D8F7WEDX",
        "googlePlacesApi": "",
        "googleAnalyticsGwDev": "UA-81735613-3"
    },
    "salesPortalUrl": "https://nnic-prod-cp.xi-1-us-west-2.guidewire.net",
    "cpProducts": [
        "Homeowners",
        "Personal Auto"
    ],
    "paymentApiUrl": "https://midas.api.omega2-andromeda.guidewire.net",
    "paymentSdkUrl": "https://js-sdk-prod.payments.guidewire.net/v1/gw-payments-sdk.js",
    "paymentTenantName": "tenant.nnic",
    "paymentConfigIds": {
        "NNINS": "10795703"
    },
    "paymentMethods": [
        "ACH",
        "CC",
        "UserSelect"
    ],
    "anonymousPaymentMethods": [
        "ACH",
        "CC",
        "UserSelect"
    ],
    "achEntryClassCode": "PPD",
    "processingFee": 0,
    "maxUploadFileSize": "500mb",
    "attachmentTemplatesLimit": "60",
    "policiesCountLimit": "20",
    "billingAccountsCountLimit": "20",
    "faviconFileExtension": "ico",
    "policyCreatedSinceDt": 365,
    "policyStatusCd": "Active, Non-Renewed, Non-Renew Requested, Cancel Notice, Cancelled",
    "passwordConstraints": [
        {
            "constraint": "minLength",
            "value": 12,
            "message": "Use at least 12 characters"
        },
        {
            "constraint": "minNumber",
            "value": 1,
            "message": "Contain at least one number"
        },
        {
            "constraint": "minLowerCase",
            "value": 1,
            "message": "Contain at least one lower case letter"
        },
        {
            "constraint": "minUpperCase",
            "value": 1,
            "message": "Contain at least one upper case letter"
        }
    ],
    "userIdConstraints": [
        {
            "constraint": "minLength",
            "value": 3,
            "message": "Use at least 3 characters"
        }
    ],
    "downTime": {
        "beginTime": "2020-01-01T17:00-05:00",
        "endTime": "2020-12-31T17:00-05:00",
        "title": "<p>System Down for Maintenance</p>",
        "body": "<p>PORTAL WILL BE TEMPORARILY UNAVAILABLE</p>"
    },
    "signIn": {
        "title": "<p></p>",
        "body": "<p><b>GO PAPERLESS</b> - Create an account and securely manage all your policies and documents online!<br><br><br><b>To GO PAPERLESS, follow these easy steps:</b><br></p><ol><li>Contact your agent to <b>confirm your email address</b> on <b>ALL</b> policies.</li><li>Log into your online account and click on <b>Customer Information</b> in the left navigation panel.</li><li>Scroll down to <b>Delivery Preferences and confirm your email address is correctly listed</b>.</li><li>Click <b>Edit</b> and then click the radial button beside <b>Paperless</b> for each policy you wish to be Paperless.</li><li>Click <b>Apply</b> in the right bottom corner to confirm.</li></ol></p>"
    },
    "notificationSmsNumber": "",
    "billingStatusCd": "Normal, Cancel, Legal",
    "apiResponseSizeLimit": 100,
    "carrierDomains": "{}",
    "_meta": {
        "build": "4.0.0-26-2ceb923",
        "commit": "2ceb923dfe5ac26823e56157430c58c167b4d42a",
        "company": "nnins",
        "date": "2025-09-04T16:24:11+00:00",
        "source": "serviceportal-four-config",
        "version": "4.0.0",
        "imageTag": ""
    }
};